/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_Remove_Segment_LabelInputs */



/**
* | output |
* | --- |
* | "Remove segment" |
*
* @param {Segment_Event_Group_Remove_Segment_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_remove_segment_label = /** @type {((inputs?: Segment_Event_Group_Remove_Segment_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_Remove_Segment_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer un segment")
	if (locale === "de") return /** @type {LocalizedString} */ ("Segment entfernen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovi segmento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить сегмент")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar segmento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("移除片段")
	if (locale === "ja") return /** @type {LocalizedString} */ ("セグメントを削除")
	if (locale === "hi") return /** @type {LocalizedString} */ ("खंड हटाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Remover segmento")
	return /** @type {LocalizedString} */ ("Remove segment")
});